export default __webpack_public_path__ + "static/media/SummaryTreeToAbsorbCo2Icon.79caaf86.svg";